// extracted by mini-css-extract-plugin
export default {"pageContainer":"LeagueLeaders_pageContainer__mhX1H","pageHeading":"LeagueLeaders_pageHeading__vwHZN","statCategory":"LeagueLeaders_statCategory__9Bp8X"};